import { render, staticRenderFns } from "./layout-grid.md?vue&type=template&id=7801e22c&"
import script from "./layout-grid.md?vue&type=script&lang=js&"
export * from "./layout-grid.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports